import { format, formatDistanceStrict } from 'date-fns'
import { de, enUS, type Locale } from 'date-fns/locale'

const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000

function resolveLocale(locale?: string): Locale {
  return locale?.startsWith('de') ? de : enUS
}

export function formatNotificationTimestamp(isoDate: string, { now = new Date(), locale }: { now?: Date; locale?: string } = {}): string {
  const parsed = new Date(isoDate)
  const date = parsed.getTime() > now.getTime() ? now : parsed
  const dateLocale = resolveLocale(locale)

  if (now.getTime() - date.getTime() < SEVEN_DAYS_MS) {
    return formatDistanceStrict(date, now, { addSuffix: true, locale: dateLocale })
  }

  const pattern = date.getFullYear() === now.getFullYear() ? 'd MMM' : 'd MMM yyyy'
  return format(date, pattern, { locale: dateLocale })
}
